import styled from '@emotion/styled';
import { LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

const Container = styled('div')<{ action: boolean }>((p) => ({
  display: 'grid',
  gridTemplateColumns: p.action
    ? '1fr max-content max-content'
    : '1fr max-content',
  gridGap: p.theme.spacing(2),
  alignItems: 'center'
}));

export const LinearProgressWithLabel = ({
  value,
  color,
  action
}: {
  value: number;
  color?: 'primary' | 'secondary';
  action?: React.ReactNode;
}) => {
  return (
    <Container action={!!action}>
      <LinearProgress variant="determinate" color={color} value={value} />

      <Typography variant="body2" color="textSecondary">{`${Math.round(
        value
      )}%`}</Typography>
      {action}
    </Container>
  );
};

export const LinearProgressIndeterminateWithLabel = ({
  label,
  color,
  action
}: {
  label: React.ReactNode;
  color?: 'primary' | 'secondary';
  action?: React.ReactNode;
}) => {
  return (
    <Container action={!!action}>
      <LinearProgress variant="indeterminate" color={color} />
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      {action}
    </Container>
  );
};
